export default {
   BASE_URL: "https://codex.inkless.digital"
}
